import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import Button from '@alltrails/denali/components/Button';
import styles from './ShowMore.module.scss';

type ShowMoreProps = {
  isLoading: boolean;
  onLoadMore: () => void;
  fullWidth?: boolean;
};

const ShowMore = ({ isLoading, onLoadMore, fullWidth }: ShowMoreProps) => {
  return (
    <Button
      className={classNames(styles.showMore, { [styles.fullWidth]: fullWidth })}
      loading={isLoading}
      onClick={onLoadMore}
      testId="trail-reviews-show-more"
      text={<FormattedMessage defaultMessage="Show more" />}
      variant="default"
      width={fullWidth ? 'full' : 'fullOnMobile'}
    />
  );
};

export default ShowMore;
